<div class="epic-confirmation">
	<div class="epic-confirmation__message">
		<epic-form-field>
			<epic-select
				[ngStyle]="{ '--status-colour': statusForm.formGroup.controls['status'].value?.colour}"
				[isClearVisible]="false"
				[control]="statusForm.formGroup.controls['status']"
				[customSelectedValues]="true">
				<div
					class="epic-select__custom-values"
					selected-values>
					<div class="epic-select__selected">
						<div
							class="epic-select__colour"
							[style.background-color]="statusForm.formGroup.controls['status'].value?.colour"></div>
						{{ getItemTranslation(statusForm.formGroup.controls['status'].value) }}
					</div>
				</div>
				@for (status of statuses; track status) {
				<epic-option
					[value]="status"
					[selected]="order?.status?.id === status.id"
					class="epic_select__option">
					<div class="epic-select__selected">
						<div
							class="epic-select__colour"
							[style.background-color]="status.colour"></div>
						{{ getItemTranslation(status) }}
					</div>
				</epic-option>
				}
			</epic-select>
		</epic-form-field>
	</div>
	<div class="epic-confirmation__actions">
		<epic-button
			[text]="confirmButtonText"
			(onClick)="updateStatus()" />
		<epic-button
			[text]="cancelButtonText"
			[isActive]="false"
			(onClick)="cancelUpdateStatus()" />
	</div>
</div>
